import colock from '../02Clock/colock.png'

function MyClockImage(){
    return (
    <img className='w-3/4 h-1/3' src={colock} alt="logo" />
    );
}

export default MyClockImage;